<form [formGroup]="orgForm">
  <div class="form">
    <div>
      <label for="">Organisation <span class="text-danger">*</span></label>
      <div>
        <p-select
          class="w-100"
          [options]="organisations"
          placeholder="Välj organisation"
          (onChange)="setOrg($event.value)"
          formControlName="selectedOrg"
        ></p-select>
      </div>
    </div>
    <div>
      <label for="">Systemroll</label>
    </div>
    <div *ngFor="let roll of roles">
      <input
        name="{{ roll.roll }}"
        class="form-check-input"
        type="checkbox"
        [(ngModel)]="roll.checked"
        [ngModelOptions]="{ standalone: true }"
      />
      <label class="form-check-label ms-2" for="">{{ getRoleLabel(roll.roll) }}</label>
    </div>
    <div>
      <label for="">Titel i organisation</label>
      <input type="text" class="form-control" formControlName="titel" />
    </div>
    <div>
      <label for="">E-postadress <span class="text-danger">*</span></label>
      <input type="text" class="form-control disabled-input" formControlName="epost" />
      @if (orgForm.get("epost")?.touched) {
        @if (orgForm.get("epost")?.errors?.["required"]) {
          <p class="text-danger">* E-post måste vara ifyllt</p>
        }
        @if (orgForm.get("epost")?.errors?.["pattern"]) {
          <p class="text-danger">* Ogiltigt e-post format</p>
        }
      }
    </div>
    <div>
      <label for="">Mobilnummer <span class="text-danger">*</span></label>
      <input type="text" class="form-control" formControlName="telefon" />
      @if (orgForm.get("telefon")?.touched) {
        @if (orgForm.get("telefon")?.errors?.["required"]) {
          <p class="text-danger">* Mobilnummer måste vara ifyllt</p>
        }
        @if (orgForm.get("telefon")?.errors?.["pattern"]) {
          <p class="text-danger">* Ogiltiga tecken</p>
        }
      }
    </div>
  </div>
  <div class="d-flex justify-content-between mt-4">
    <app-button text="Avbryt" buttonStyle="secondary" (click)="cancel()"></app-button>
    <app-button [disabled]="orgForm.invalid" text="Spara" buttonStyle="primary" [callback]="save"></app-button>
  </div>
</form>
